import React from 'react';
import LanguageSwitcher from '../LanguageSwitcher';
import './Navbar.css';

const Navbar = ({ setPage }) => {
    return (
        <nav className="navbar">
            <div
                className="navbar-logo"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    if (setPage) setPage('home');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
            >
                <h1>VitaPlex</h1>
            </div>
            <div className="navbar-actions">
                <LanguageSwitcher />
            </div>
        </nav>
    );
};

export default Navbar;
